

import React from "react";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { formatPrice, roundCurrency } from "../Utility/Utility";
import { calculateCartPricing } from "./hooks/useCartPricing";

const RightCart = ({
  productReducer,
  updatedData,
}) => {
  const translation = getTranslationData();

  // product id & mapping data
  // const productId = productReducer?.productReducerDisocount?.id;

  // const ClientProductMappingData = useSelector(
  //   (state) =>
  //     state?.ClientProductMappingbyIdReducer.data?.[0]?.clientProductMapping
  // );
  const {
    totalDenomination,
    totalQuantity,
    convenienceFeeAmount,
    gstAmount,
    totalDiscount,
    convenienceFeePercent,
    customerDiscount,
  } = calculateCartPricing(updatedData, productReducer?.productReducer);
  const totalPayableAmount = roundCurrency(
    (totalDenomination - totalDiscount) + convenienceFeeAmount + gstAmount
  );



  return (
    <div className="totalAmaountCard">
      <div className="bg-white rightCart bnb">
        <div className="info">
          {/* Total Giftcards */}
          <div className="d-flex justify-content-between jlkk pb-2">
            <div className="mr-4 lsss2">
              {totalQuantity} {translation?.giftCard}{totalQuantity > 1 ? 's' : ''}
            </div>
            <div className="lsss3">₹{totalDenomination.toLocaleString()}</div>
          </div>

          {customerDiscount > 0 && (
            <div className="d-flex justify-content-between jlkk pb-2">
              <div className="mr-4 lsss2">{translation?.discount}</div>
              <div className="lsss3"><span className="discountMinusText">-</span>₹{formatPrice(totalDiscount)}</div>
            </div>
          )}

          {/* Convenience Fee + GST */}
          {(convenienceFeeAmount > 0 || gstAmount > 0) && (
            <div className="d-flex justify-content-between jlkk pb-2">
              <div className="mr-4 lsss2">
                {convenienceFeeAmount > 0 && (
                  <>
                    <span className="d-block">
                      {translation?.convenience_fe}
                    </span>
                    <span>{convenienceFeePercent}%</span>
                  </>
                )}
                {gstAmount > 0 && <span>{translation?.plus_gst}</span>}
              </div>
              <div className="lsss3">
                ₹{formatPrice(convenienceFeeAmount + gstAmount)}
              </div>
            </div>
          )}

          {/* Total Amount */}
          <div className="d-flex justify-content-between jlkk">
            <div className="mr-4 lsss3 lssss4">{translation?.totalAmount}</div>
            <div className="lsss3">₹{formatPrice(totalPayableAmount)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RightCart;
